export type ActivityPinColorPair = {
  background: string;
  text: string;
};

export const DEFAULT_ACTIVITY_PIN_COLOR_PAIR: ActivityPinColorPair = {
  background: '#ffec9e',
  text: '#1F2937',
};

export const ACTIVITY_PIN_COLOR_PAIRS: ActivityPinColorPair[] = [
  { background: '#FEE2E2', text: '#1F2937' },
  { background: '#FFEDD5', text: '#1F2937' },
  { background: '#FEF3C7', text: '#1F2937' },
  { background: '#DCFCE7', text: '#1F2937' },
  { background: '#D1FAE5', text: '#1F2937' },
  { background: '#DBEAFE', text: '#1F2937' },
  { background: '#E0E7FF', text: '#1F2937' },
  { background: '#F3E8FF', text: '#1F2937' },
];

export function pickRandomActivityPinColorPair(): ActivityPinColorPair {
  const index = Math.floor(Math.random() * ACTIVITY_PIN_COLOR_PAIRS.length);
  return ACTIVITY_PIN_COLOR_PAIRS[index] ?? DEFAULT_ACTIVITY_PIN_COLOR_PAIR;
}
